import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import clientsAll from '../../graphql/queries/clientsAll'
import QUERY_KEYS from '../../graphql/queryKeys'
import { RECEIVE_ALL_CLIENTS_SUCCESS } from '../hauler/clients/action/clientAction'
import { captureErrorAndNotify } from '../../utilities/errorHandlers'

const NO_CLIENTS = []

export default function useAllClients () {
  const allClients = useSelector(({ allClients }) => allClients)
  const dataLoaders = useSelector(({ dataLoaders }) => dataLoaders)
  const haulerId = useSelector(({ user }) => user.user?.haulerId)
  const dispatch = useDispatch()

  const fetchAllClients = useCallback(() => {
    if (!haulerId) return

    clientsAll({
      dataLoaders,
      queryKey: [
        QUERY_KEYS.clientsAll,
        haulerId,
        {
          column: 'name',
          direction: 'DESC'
        },
        null,
        null,
        null,
        null,
        null
      ]
    })
      .then((resp) => {
        dispatch({
          type: RECEIVE_ALL_CLIENTS_SUCCESS,
          payload: {
            clients: resp.clientsAll
          }
        })
      })
      .catch((error) => {
        captureErrorAndNotify(
          error,
          'Error fetching Accounts'
        )
      })
  }, [
    dataLoaders,
    dispatch,
    haulerId
  ])

  useEffect(() => {
    fetchAllClients()
  }, [fetchAllClients])

  return {
    clients: Array.isArray(allClients?.clients) ? allClients.clients : NO_CLIENTS,
    isClientsFetching: allClients?.isFetching
  }
}
